const url = 'http://server.martymagaan.com:3003';

const post = (data, callback) => {
  console.log(data);
  const http = new XMLHttpRequest();
  http.open('POST', url);
  http.setRequestHeader('Content-Type', 'application/json');
  http.onreadystatechange = function () {
    if (this.readyState === XMLHttpRequest.DONE && this.status === 200)
      if (callback) callback();
  };
  data = JSON.stringify(data)
  http.send(data);
}

const db = {
  createUser: (options) => {
    post(options, () => console.log('User created'));
  }
};

export default db;
